import { AsnReportsView } from '../../asnReports/view/asnReportsView';
import { CertificateReportsView } from '../../certificateReports/view/certificateReportsView';
import { DiscoveredIpsView } from '../../discoveredIps/view/discoveredIpsView';
import { DiscoveredEmailsView } from '../../discoveredEmails/view/discoveredEmailsView';
import { DiscoveredDomainsView } from '../../discoveredDomains/view/discoveredDomainsView';
import { DnsRecordsView } from '../../dnsRecords/view/dnsRecordsView';
import { ServicesView } from '../../services/view/servicesView';
import { DiscoveredIpsBlock } from '../../discoveredIpsBlock/view/discoveredIpsBlock';
import { Assignee, ExpirationStatus, FindingClassType, FindingType } from '../../../types';
import { NextScanInclusionStatus } from '../../../assetsInventoryGrid/types';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { InvestigationPriority, InvestigationStatus } from '../../../../investigation/types';

type FindingDetailsByType = {
  [K in FindingType]: typeof BaseSpecificDetailsView;
};
export const FINDING_DETAILS_BY_TYPE: FindingDetailsByType = {
  [FindingType.ASN_REPORT]: AsnReportsView,
  [FindingType.CERTIFICATE_REPORT]: CertificateReportsView,
  [FindingType.IP_4]: DiscoveredIpsView,
  [FindingType.IP_6]: DiscoveredIpsView,
  [FindingType.IP_BLOCK]: DiscoveredIpsBlock,
  [FindingType.EMAIL]: DiscoveredEmailsView,
  [FindingType.DOMAIN]: DiscoveredDomainsView,
  [FindingType.SIMILAR_DOMAIN]: DiscoveredDomainsView,
  [FindingType.DNS_RECORD]: DnsRecordsView,
  [FindingType.SERVICE]: ServicesView,
};

export enum EASMActions {
  COPY_TO_CLIPBOARD_IP = 'copyToClipboardIp',
  COPY_TO_CLIPBOARD_EMAIL = 'copyToClipboardEmail',
  VIEW_INCIDENTS_IP = 'viewIncidentsIp',
  VIEW_INCIDENTS_EMAIL = 'viewIncidentsEmail',
}

export enum EASMSidePanelEvents {
  SHOW_NEW_ASSET = 'showNewAsset',
  FILTER_RELATED_ASSET = 'filterRelatedAsset',
}

export const NUMBER_OF_RELATED_FINDINGS_TO_DISPLAY_IN_BULK = 3;

export interface RelatedFinding {
  name: string;
  id: string;
  class: FindingClassType;
  type: FindingType;
  isVulnerable: boolean;
  cves: string[];
  notAfter: number;
  status: string;
  expirationStatus: ExpirationStatus;
}

export interface FindingGroupItemsByClass {
  assets: FindingGroup[];
  artifacts: FindingGroup[];
}

export interface FindingGroup {
  count: number;
  type: FindingType;
  items: RelatedFinding[];
}

export interface FindingDetailsPayload {
  _id: string;
  type: FindingType;
  class: FindingClassType;
  companyId: string;
  companyName?: string;
  uniqueIdentifier: string;
  scanId: string;
  name: string;
  dateAdded: Date;
  canPivotToIncidents: boolean;
  nextScanStatus: NextScanInclusionStatus;
  email?: string;
  domain?: string;
  ip?: string;
  country?: string;
  operator?: string;
  number?: string;
  certificateId?: string;
  issuerName?: string;
  certificateCommonName?: string;
  notBefore?: number;
  notAfter?: number;
  expirationStatus?: ExpirationStatus;
  serialNumber?: string;
  recordType?: string;
  mailServer?: string;
  nameServer?: string;
  cname?: string;
  port?: number;
  protocol?: string;
  cves?: string[];
  isVulnerable?: boolean;
  version?: string;
  cidr?: string;
  status?: string;
  new?: boolean;
  cvesDetailedList?: CveDetail[];
  groupedByType?: FindingGroupItemsByClass;
  metadata: {
    investigation: {
      status: InvestigationStatus;
      priority: InvestigationPriority;
      notesCount: number;
    };
  };
  assignee: Assignee | null;
}

interface RiskScore {
  value: number;
  severity: string;
}

export interface CveDetail {
  standardId: string;
  hasExploit: boolean;
  riskScore: RiskScore;
  summary: string;
  isIndustryTargeted: boolean;
}

export type OnClickDetailHandler = (classType: FindingClassType, findingType: FindingType | undefined) => void;
